module.exports = __webpack_public_path__ + "img/model-poster-img.d70f3505.png";